import { inject, Injectable } from '@angular/core';
import { Camera } from '@models';
import { AppService, SimulationService } from '@services';

@Injectable({
  providedIn: 'root',
})
export class CameraService {
  protected appService = inject(AppService);
  protected simulationService = inject(SimulationService);

  videoStream: MediaStream;

  selectedCamera: Camera = null;
  deviceId: string;

  getCameras(): void {
    navigator.mediaDevices
      .getUserMedia({
        audio: false,
        video: {
          facingMode: { ideal: 'environment' },
          deviceId: this.deviceId ? { exact: this.deviceId } : undefined,
        },
      })
      .then((stream) => {
        navigator.mediaDevices.enumerateDevices().then((devices) => {
          this.appService.cameras = devices
            .filter((device) => device.kind === 'videoinput')
            .map((device) => ({
              label: device?.label,
              id: device.deviceId,
            }))
            .reverse();
          if (
            this.appService.cameras.find(
              (camera) => camera.label === 'Back Camera',
            )
          ) {
            this.appService.cameraId.set(
              this.appService.cameras.filter(
                (camera) => camera.label === 'Back Camera',
              )[0].id,
            );
          } else {
            this.appService.cameraId.set(this.appService.cameras[0].id);
          }
        });
      });
  }
}
